export const mockAvailableLocales = {
  availableLocales: ['en-US', 'fr-FR', 'es-ES']
}
